// LocalStorage keys
export const STORAGE_KEYS = {
    AUTH_TOKEN: 'auth-token',
    SESSION_TOKEN: 'session-token',
    USER_DATA: 'user-data',
    THEME: 'theme',
    LANGUAGE: 'language',
} as const;

// SessionStorage keys
export const SESSION_KEYS = {
    REDIRECT_URL: 'redirect-url',
    TEMP_DATA: 'temp-data',
} as const;

